<template>
  <v-btn color="primary lighten-2"
         small
         icon
         :disabled="requestState === 'Loading'"
         :loading="requestState === 'Loading'"
         @click="handleClickExport">
    <v-icon small>fas fa-file-download</v-icon>
  </v-btn>
</template>

<script>
  import FileSaver from 'file-saver'
  import {RequestState} from '../../../requestState'
  import {notificationService} from '../../../application'
  import axios from 'axios'

  export default {
    name: 'export-cases-as-csv',
    props: {
      filters: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        requestState: RequestState.NotPerformed
      }
    },
    methods: {
      handleClickExport() {
        if (this.requestState === RequestState.Loading) {
          return
        }

        this.requestState = RequestState.Loading;

        const resultFilters = this.filters;
        axios.get(`/api/cases/export-to-csv`, {
          params: {
            filters: this.filters
          }
        })
          .then((data) => {
            this.requestState = RequestState.Success;
            const csv = '\ufeff' + data.data;
            let blob = new Blob([csv], {type: 'text/csv;charset=UTF-8;'});
            FileSaver.saveAs(blob, `cases.csv`)
          })
          .catch(e => {
            notificationService.error('Can\'t perform operation');
            this.requestState = RequestState.Failed;
          })
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/ExportCasesAsCsv.vue